export default __webpack_public_path__ + "static/media/antp_CartaPorte3_ReviveLaTransmision.6ec1ae30.jpg";